import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ibm-aiops-training/ibm-aiops-training/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Accordion = makeShortcode("Accordion");
const AccordionItem = makeShortcode("AccordionItem");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`In this section you will enable a Policy to create Stories and create a Policy to assign a Runbook to a Story.`}</p>
    <h2>{`🚀 TASK: Enable Story creation Policy`}</h2>
    <a href="https://www.ibm.com/docs/en/cloud-paks/cloud-pak-aiops/4.6.0?topic=policies-default-story-creation" target="_blank">🌏 Documentation for the Task: Default story creation policies</a>
    <p>{`CP4AIOPS provides two preset/of the box story creation policies. For story creation to occur, you must enable one of these default policies, or create your own custom story creation policy. These policies are disabled by default.`}</p>
    <Accordion mdxType="Accordion">
      <AccordionItem title="💡 Solution?" mdxType="AccordionItem">
        <ol>
          <li parentName="ol">
            <p parentName="li">{`In the `}<inlineCode parentName="p">{`CP4AIOPS`}</inlineCode>{` “Hamburger” Menu select `}<inlineCode parentName="p">{`Operate`}</inlineCode>{`/`}<inlineCode parentName="p">{`Automations`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Select tab `}<inlineCode parentName="p">{`Policies`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Click on the `}<inlineCode parentName="p">{`Tag`}</inlineCode>{` dropdown`}</p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Select `}<inlineCode parentName="p">{`Stories`}</inlineCode>{` and `}<inlineCode parentName="p">{`Runbooks`}</inlineCode></p>
            <img parentName="li" {...{
              "src": "./../images/33_policy.png",
              "alt": "image"
            }}></img>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Turn on Policy `}<inlineCode parentName="p">{`Default story creation policy for all alerts`}</inlineCode>{` `}</p>
            <img parentName="li" {...{
              "src": "./../images/34_policy.png",
              "alt": "image"
            }}></img>
          </li>
        </ol>
      </AccordionItem>
    </Accordion>
    <h2>{`🚀 TASK: Create Runbook Assignment policy`}</h2>
    <a href="https://www.ibm.com/docs/en/cloud-paks/cloud-pak-aiops/4.6.0?topic=policies-assign-runbook-alerts" target="_blank">🌏 Documentation for the Task: Assign a runbook to alerts</a>
    <p>{`For this training, you want to have a runbook take action when you receive alerts stating that the MySQL database is not reachable.
Create a policy to assign this runbook every time we get alerts related to a problem with the MySQL database.`}</p>
    <Accordion mdxType="Accordion">
      <AccordionItem title="💡 Solution?" mdxType="AccordionItem">
        <ol>
          <li parentName="ol">
            <p parentName="li">{`Click on `}<inlineCode parentName="p">{`Create Policy`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Click on `}<inlineCode parentName="p">{`Assign a runbook to alerts`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Name it `}<inlineCode parentName="p">{`RobotShop Mitigate MySQL Problem`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Scroll down to `}<inlineCode parentName="p">{`Condition sets`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Click `}<inlineCode parentName="p">{`Add Condition`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Select `}<inlineCode parentName="p">{`Alert Property`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Click in field  `}<inlineCode parentName="p">{`Property`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Type `}<inlineCode parentName="p">{`name`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Select `}<inlineCode parentName="p">{`resource`}</inlineCode>{` / `}<inlineCode parentName="p">{`name`}</inlineCode></p>
            <img parentName="li" {...{
              "src": "./../images/35_runbook.png",
              "alt": "image"
            }}></img>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Under `}<inlineCode parentName="p">{`Operator`}</inlineCode>{` select `}<inlineCode parentName="p">{`contains`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Click in field  `}<inlineCode parentName="p">{`Value`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Type `}<inlineCode parentName="p">{`mysql`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Select `}<inlineCode parentName="p">{`String: mysql`}</inlineCode></p>
            <img parentName="li" {...{
              "src": "./../images/36_runbook.png",
              "alt": "image"
            }}></img>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Check runbook `}<inlineCode parentName="p">{`RobotShop Mitigate MySQL Problem`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Check `}<inlineCode parentName="p">{`Use default parameter value`}</inlineCode></p>
            <img parentName="li" {...{
              "src": "./../images/37_runbook.png",
              "alt": "image"
            }}></img>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Click `}<inlineCode parentName="p">{`Create Policy`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Your list of Policies should now look like this`}</p>
            <img parentName="li" {...{
              "src": "./../images/38_runbook.png",
              "alt": "image"
            }}></img>
          </li>
        </ol>
      </AccordionItem>
    </Accordion>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      